import { defineFcm } from '../shared/factory';

export const FCM_TOPIC_CLASSIFIER_SERVICE_AUTO_WRITE_ENABLED = defineFcm('topic_classifier_service_auto_write_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
